import { BranchOffice, Seller } from '../types/branch-office.types';
import { BaseApiService } from '../../common/services/baseApiService';
import { API_URL } from '../../common/utils/util';

export class BranchOfficeService extends BaseApiService {
  static async getBranchOffices(): Promise<BranchOffice[]> {
    try {
      const response = await fetch(`${API_URL}/branch-offices?chain=MRH`, {
        method: 'GET',
        headers: this.getAuthHeaders(),
      });

      const branchOffices: BranchOffice[] = await this.handleResponse<BranchOffice[]>(response);
      return branchOffices;
    } catch (error) {
      console.error('Get branch offices error:', error);
      throw error;
    }
  }

  static async getBranchOfficesByChain(chainId: string): Promise<BranchOffice[]> {
    try {
      const response = await fetch(`${API_URL}/branch-offices?chain=${chainId}`, {
        method: 'GET',
        headers: this.getAuthHeaders(),
      });

      const branchOffices: BranchOffice[] = await this.handleResponse<BranchOffice[]>(response);
      return branchOffices;
    } catch (error) {
      console.error('Get branch offices by chain error:', error);
      throw error;
    }
  }

  static async getSellersByChainAndBranch(chainId: string, branchId: number): Promise<Seller[]> {
    try {
      const response = await fetch(`${API_URL}/branch-offices/sellers?chain=${chainId}&branchOffice=${branchId}`, {
        method: 'GET',
        headers: this.getAuthHeaders(),
      });

      const sellers: Seller[] = await this.handleResponse<Seller[]>(response);
      return sellers;
    } catch (error) {
      console.error('Get sellers by chain and branch error:', error);
      throw error;
    }
  }
} 